import Logo from "../assets/icon_no-cursive.png";
import "../css/footer.css"

const Footer = () => {
    return (
        <div className="container footer__container">
            <img src={Logo} alt="logo"/>
        </div>
    )
};

export default Footer;